export default __webpack_public_path__ + "f3751250ac2be2df0e21dc02e73584c9.svg";